<template>
    <div>
        <!-- <img v-show="quizMask"
            class="quiz_mask"
            :src="contents.currentSlide.quizMask" 
        > -->
        <div v-show="quizMask"
            class="quiz_intro"
            :style="{'background-image': 'url(\'' + contents.currentSlide.quizMask + '\')'}"
            @click="removeQuizMask"
        >
            <img class="quiz_intro_text"
                :src="contents.currentSlide.quizIntroText"  alt=""
            >
            <img class="quiz_intro_start"
                :src="contents.currentSlide.quizMaskStart"  alt=""
            >
        </div>
        <div v-for="(quiz,index) in contents.currentSlide.quiz" :key="index">
            <div v-if="quiz.type == 'ox'">
                <aw-ox-quiz
                    v-if="currentQuiz == index"
                    :quiz=quiz
                    :order="index"
                    :currentSlide="contents.currentSlide"
                    v-on:answered="answered"
                    v-on:goQuizNext="goQuizNext"
                ></aw-ox-quiz>
            </div>
            <div v-else-if="quiz.type == 'multiple'">
                <aw-multiple-quiz
                    v-if="currentQuiz == index"
                    :quiz=quiz
                    :order="index"
                    v-on:answered="answered"
                    v-on:goQuizNext="goQuizNext"
                ></aw-multiple-quiz>
            </div>
        </div>
        <div v-if="resultFlag">
            <aw-quiz-result
                :result=result 
                v-on:goQuizNext="goQuizNext"
                v-on:goSupplementary="goSupplementary"
            ></aw-quiz-result>
        </div>
        <div v-if="supplementaryFlag">
            <aw-supplementary
                :contents=contents
                :result=result 
                v-on:goNext="goNext"
            ></aw-supplementary>
        </div>
        <audio v-if="contents.currentSlide.bgm != undefined" ref="currentAudio">
            <source :src="'../assets/media/' + contents.currentSlide.bgm" type="audio/mpeg">
        </audio>
    </div>
</template>
<script>
import {pad} from '../../helpers'
export default {
    props : ['contents'],
    data(){
        return{
            currentQuiz : 0,
            result : _.map(new Array(this.contents.currentSlide.quiz.length),{
                result : false
            }),
            resultFlag : false,
            supplementaryFlag : false,
            quizMask : true,
        }
    },
    methods:{
        answered(order,answer){//from children
            this.result[order] = answer;//store result
        },
        goQuizNext(order){//from children
            if(order < this.contents.currentSlide.quiz.length){// still quiz
                this.currentQuiz = order;
                this.resultFlag = false;
            }else{// end quiz show result
                this.currentQuiz = order;
                this.resultFlag = true
            }
        },
        goSupplementary(){
            if(this.contents.currentSlide.supplementary != undefined){
                this.resultFlag = false;
                this.supplementaryFlag = true;
            }else{
                this.goNext();
            }
        },
        goNext(){
            // location.href = "./" + pad(this.contents.slideNumber + 1) + ".html";
            if(typeof settings.nextPage !== 'undefined' && settings.nextPage != null){
                return  settings.nextPage(this.contents.slideNumber);
            }
            location.href = "./" + pad(this.contents.slideNumber + 1) + ".html";
        },
        removeQuizMask(){
            this.quizMask = false;
        }
    },
    mounted(){
        setTimeout(()=>{
            this.$refs.currentAudio.play()
        }, 1000);
    }
}
</script>